import { createRouter, createWebHistory } from 'vue-router';
import { ReviseMeta } from '@/util/meta';
import { deviceType } from '@/util/base';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 入口页面
    {
      path: '/',
      component: () => import('./views/gw/index.vue'),
    },
    // 东南亚预约 PC端
    {
      path: '/pre',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '《Zero to Hero: Pixel Saga》Pre-register for 2024 Draws!',
        keywords: 'Zero to Hero, pixel, adventure, RPG, idle, Pixel HERO, Maple Rush, hero, 2024 draws',
        description: '"Zero to Hero" pixel adventure RPG is available for pre-registration! Reincarnate into a different world, start from zero and rise up to become a hero.  Pre-register to immediately receive 2024 continuous draws and SR Vishapheo!'
      }
    },
    // 东南亚预约 wap端
    {
      path: '/pre/m',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '《Zero to Hero: Pixel Saga》Pre-register for 2024 Draws!',
        keywords: 'Zero to Hero, pixel, adventure, RPG, idle, Pixel HERO, Maple Rush, hero, 2024 draws',
        description: '"Zero to Hero" pixel adventure RPG is available for pre-registration! Reincarnate into a different world, start from zero and rise up to become a hero.  Pre-register to immediately receive 2024 continuous draws and SR Vishapheo!'
      }
    },
    // 欧美预约 PC端
    {
      path: '/us/pre',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '《Zero to Hero: Pixel Saga》Pre-register for 2024 Draws!',
        keywords: 'Zero to Hero, pixel, adventure, RPG, idle, Pixel HERO, Maple Rush, hero, 2024 draws',
        description: '"Zero to Hero" pixel adventure RPG is available for pre-registration! Reincarnate into a different world, start from zero and rise up to become a hero.  Pre-register to immediately receive 2024 continuous draws and SR Vishapheo!'
      }
    },
    {
      path: '/us/pre/m',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '《Zero to Hero: Pixel Saga》Pre-register for 2024 Draws!',
        keywords: 'Zero to Hero, pixel, adventure, RPG, idle, Pixel HERO, Maple Rush, hero, 2024 draws',
        description: '"Zero to Hero" pixel adventure RPG is available for pre-registration! Reincarnate into a different world, start from zero and rise up to become a hero.  Pre-register to immediately receive 2024 continuous draws and SR Vishapheo!'
      }
    },
    // 营销广告投放页
    {
      path: '/pre/GG',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '《Zero to Hero: Pixel Saga》Pre-register for 2024 Draws!',
        keywords: 'Zero to Hero, pixel, adventure, RPG, idle, Pixel HERO, Maple Rush, hero, 2024 draws',
        description: '"Zero to Hero" pixel adventure RPG is available for pre-registration! Reincarnate into a different world, start from zero and rise up to become a hero.  Pre-register to immediately receive 2024 continuous draws and SR Vishapheo!'
      }
    },
    {
      path: '/pre/TT',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '《Zero to Hero: Pixel Saga》Pre-register for 2024 Draws!',
        keywords: 'Zero to Hero, pixel, adventure, RPG, idle, Pixel HERO, Maple Rush, hero, 2024 draws',
        description: '"Zero to Hero" pixel adventure RPG is available for pre-registration! Reincarnate into a different world, start from zero and rise up to become a hero.  Pre-register to immediately receive 2024 continuous draws and SR Vishapheo!'
      }
    },
    {
      path: '/pre/FB',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title: '《Zero to Hero: Pixel Saga》Pre-register for 2024 Draws!',
        keywords: 'Zero to Hero, pixel, adventure, RPG, idle, Pixel HERO, Maple Rush, hero, 2024 draws',
        description: '"Zero to Hero" pixel adventure RPG is available for pre-registration! Reincarnate into a different world, start from zero and rise up to become a hero.  Pre-register to immediately receive 2024 continuous draws and SR Vishapheo!'
      }
    },
    // 协议
    // 东南亚
    {
      path: '/protocol',
      component: () => import('./views/protocol.vue'),
    },
    // 欧美
    {
      path: '/protocol-na',
      component: () => import('./views/na-protocol.vue'),
    },
    // 下载
    {
      path: '/down',
      children: [
        // 广告-抖音A版
        {
          path: 'TT-A',
          component: () => import('./views/down/A.vue')
        },
        // 广告-抖音B版
        {
          path: 'TT-B',
          component: () => import('./views/down/B.vue')
        },
        // 广告-抖音C版
        {
          path: 'TT-C',
          component: () => import('./views/down/C.vue')
        },
        // 广告-脸书A版
        {
          path: 'FB-A',
          component: () => import('./views/down/A.vue')
        },
        // 广告-脸书B版
        {
          path: 'FB-B',
          component: () => import('./views/down/B.vue')
        },
        // 广告-脸书C版
        {
          path: 'FB-C',
          component: () => import('./views/down/C.vue')
        },
        //
        {
          path: 'FB-B2',
          component: () => import('./views/down/B2.vue')
        },
        {
          path: 'FB-C2',
          component: () => import('./views/down/C2.vue')
        },
        {
          path: 'FB-D2',
          component: () => import('./views/down/D2.vue')
        },
        // 广告-谷歌A版
        {
          path: 'GG-A',
          component: () => import('./views/down/A.vue')
        },
        // 广告-谷歌B版
        {
          path: 'GG-B',
          component: () => import('./views/down/B.vue')
        },
        // 广告-谷歌C版
        {
          path: 'GG-C',
          component: () => import('./views/down/C.vue')
        },
        // 广告-抖音D版
        {
          path: 'TT-D',
          component: () => import('./views/down/D.vue')
        },
        // 广告-脸书D版
        {
          path: 'FB-D',
          component: () => import('./views/down/D.vue')
        },
        // 广告-谷歌D版
        {
          path: 'GG-D',
          component: () => import('./views/down/D.vue')
        },
      ]
    },
    // 404
    {
      path: '/:pathMatch(.*)*',
      component: () => import('../../components/404.vue')
    },
  ],
});


router.beforeEach((to, from, next) => {
  // 路由发生变化改变description和keyword
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description)
  // 只在特定路由路径下执行刷新
  if (to.name === 'yymen') {
    // location.reload();
  }

  // 根据PC或者移动端跳转
  if (deviceType() == 'wap') {
    if (to.path == "/pre") {
      next({ path: "/pre/m", query: to.query });
    } else if (to.path == "/us/pre") {
      next({ path: "/us/pre/m", query: to.query });
    } else {
      next();
    }
  } else {
    if (to.path == "/pre/m") {
      next({ path: "/pre", query: to.query });
    } else if (to.path == "/us/pre/m") {
      next({ path: "/us/pre", query: to.query });
    } else {
      next();
    }
  }
  next()
})

export default router;
